import { Grid } from '@mui/material';
import EpisodeCardController from '@controllers/EpisodeCardController';

export default function EpisodeList({ episodes, onPlayClick }) {
  return (
    <Grid container spacing={{ xs: 2, sm: 3 }}>
      {episodes.map((episode) => (
        <Grid item xs={12} sm={6} md={4} key={episode.id}>
          <EpisodeCardController
            episode={episode}
            onPlayClick={onPlayClick}
          />
        </Grid>
      ))}
    </Grid>
  );
}
